"use client";

import { useSyncExternalStore } from "react";
import { ChevronRight, Smartphone } from "lucide-react";
import { OPEN_GEBEURTENIS, alsApp, leesToestel } from "@/lib/installeren";

// Terugweg naar de installatietip.
//
// De strook onderin verdwijnt na een "Later" twee weken lang. Zonder deze rij
// is dat een deur die achter je in het slot valt: wie hem eerst wegtikte en er
// later toch aan wil, kan hem nergens meer vinden. Op een iPhone is dat ook de
// enige weg naar werkende meldingen.
//
// Of de rij zin heeft, hangt van het toestel af - en dat weet de server niet.
// Net als bij de favorieten lezen we die buitenwereld met useSyncExternalStore
// in plaats van met een effect, zodat de server gewoon niets rendert.
function abonneer(meld: () => void): () => void {
  window.addEventListener("appinstalled", meld);
  return () => window.removeEventListener("appinstalled", meld);
}

function hier(): boolean {
  return !alsApp() && leesToestel() !== "bureaublad";
}

function opDeServer(): boolean {
  return false;
}

export function BeginschermRij() {
  const tonen = useSyncExternalStore(abonneer, hier, opDeServer);

  if (!tonen) return null;

  return (
    <li>
      <button
        type="button"
        onClick={() => window.dispatchEvent(new Event(OPEN_GEBEURTENIS))}
        className="flex w-full items-center gap-3 rounded-xl border border-border bg-card px-3 py-3 text-left transition-colors active:bg-white/5"
      >
        <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted text-primary">
          <Smartphone className="size-5" aria-hidden />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-display text-base font-bold uppercase tracking-wide text-white">
            Op je beginscherm
          </p>
          <p className="truncate text-xs text-muted-foreground">Openen zonder browser, ook zonder bereik</p>
        </div>
        <ChevronRight className="size-5 shrink-0 text-white/30" aria-hidden />
      </button>
    </li>
  );
}
